/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './importRepo.defs'
export { main as default } from './importRepo.defs'
